import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { ACCESS_ROLE_LABEL, type AccessRole } from '@/constants/rbac';
import { cn } from '@/lib/utils';

type AccessProfileSelectProps = {
  value?: string;
  options: AccessRole[];
  error?: string;
  onChange: (_value: string) => void;
};

export const AccessProfileSelect = ({ value, options, error, onChange }: AccessProfileSelectProps) => {
  const [open, setOpen] = useState(false);
  const label = value ? ACCESS_ROLE_LABEL[value as AccessRole] : '';

  return (
    <div className="space-y-1.5">
      <label className="text-sm font-semibold text-gray-900">
        Perfil de acesso <span className="text-red-500">*</span>
      </label>
      <Popover open={open} onOpenChange={setOpen} modal={false}>
        <PopoverTrigger asChild>
          <button
            type="button"
            className={cn(
              'flex h-10 w-full items-center justify-between rounded-md border bg-white px-3 text-sm shadow-xs shadow-input',
              error ? 'border-red-500' : 'border-input',
              label ? 'text-gray-900' : 'text-muted-foreground'
            )}
          >
            <span className="truncate">{label || 'Selecione'}</span>
            <ChevronDown className="h-4 w-4 text-gray-500" />
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="z-[80] w-[var(--radix-popover-trigger-width)] p-1">
          {options.map((role) => (
            <button
              key={role}
              type="button"
              className="flex w-full rounded-sm px-3 py-2 text-left text-sm hover:bg-gray-100"
              onClick={() => {
                onChange(role);
                setOpen(false);
              }}
            >
              {ACCESS_ROLE_LABEL[role]}
            </button>
          ))}
        </PopoverContent>
      </Popover>
      {error ? <p className="text-xs font-medium text-red-500">{error}</p> : null}
    </div>
  );
};
